import { millisecondsInSecond } from "~/tools/date-time";
import { floor } from "~/tools/floor";
import { max } from "~/tools/max";

/**
 * Calculates the Frames Per Second interval (FPS) in ms.
 * FPS is how many frames are displayed per second.
 * If fps is 20, then 20 frames are displayed per second with an interval of 1000ms/20=50ms.
 *
 * @param frames - The number of frames to calculate the FPS for.
 * @returns The FPS interval in ms.
 */
export function fps(frames: number): number {
	return floor(millisecondsInSecond / max(frames, 1), 0);
}
